import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import { Accordion, Grid, Header, Icon, Image, Label, Message, Segment } from "semantic-ui-react";
import styles from "../../../../Assessment/AssessmentInfoSlideControls/LearnMoreTemplate.module.css"

const cdnRoute = process.env.REACT_APP_CDN_ROUTE + "/spiritual/";
const iconRoute = process.env.REACT_APP_CDN_ROUTE + "/icons/";

const ChurchContactsLearnMore: React.FC = () => {
  const [activeAccordionIndexes] = useState([0]);

  const renderAccordionTips = () => {
    return (
      <>   
      <Grid stackable className={styles.learnMoreFullDiv} >
        <Grid.Row stretched columns='equal' className={styles.highlightsItemRow} >
          <Grid.Column width={5} container className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColMiddle} `}>
            <Message className={styles.highlightsItemWhiteBG} info>
              <Header as='h2' icon className={styles.highlightsItemHeader} >
                <Header.Subheader > 
                  <p className={styles.learnMoreAccordionTextEmphasis}><br/>Especially if you live far, it is helpful to have a point of 
                    contact at the older adult's church in case of illness or emergency.<br/><br/> </p>
                </Header.Subheader>
              </Header>
            </Message>
          </Grid.Column>
          <Grid.Column stretched className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColMiddle} `}>
            <Segment raised className={styles.highlightsItemWhiteBG} >  
              <Header as='h2' icon className={styles.highlightsItemHeader} >
                <Image src={`${iconRoute}friendship-10.png`} className={styles.highlightsItemHeaderImgIcon} />
                LOOKING OUT FOR ONE ANOTHER
                <Header.Subheader>  
                    <p className={styles.learnMoreAccordionText} > With the older adult's permission, church friends and clergy can be 
                        especially helpful to you in alerting you to changes and issues that may arise between your visits with the 
                        older adult.
                        <br/></p>
                </Header.Subheader>
              </Header>
            </Segment>  
          </Grid.Column>
        </Grid.Row>
      </Grid>    
      </>
    );
  };


  const accordions = [
    { key: 'help',
      index: 0,
      title: { 
        icon: <Icon name='dropdown' className={styles.learnMoreAccordionLabelTitleIcon} />, 
        content: <Label className={styles.learnMoreAccordionLabelTitle} > Finding Sources of Help </Label> },
      content: { 
        content: (<Message className={styles.learnMoreAccordionMessageBox} content={renderAccordionTips()}/>)
      }
    },
  ];

  
  return (
    <>
      <Segment className={styles.learnMoreBackgroundImg} style = {{ backgroundImage: `url(${cdnRoute}churchcontacts_learnmore.jpg)`, }}>
        <div className={styles.learnMoreModalContent}>

          <div className={styles.learnMoreAccordionFullDivGrid} >
            <div className={styles.learnMoreAccordionFullDiv} >
              <Accordion panels={accordions} className={styles.learnMoreModalAccordionGroup} defaultActiveIndex={activeAccordionIndexes} exclusive={false} />
            </div> 
          </div>  

        </div>
      </Segment>      
    </>
  );  
};

export default observer(ChurchContactsLearnMore);
